import { PropsWithChildren } from 'react'
import { AskLoginModal } from '@wellesley/auth'
import { BuildInfo } from '../../features/build-info/BuildInfo'

export const MainLayout = ({ children }: PropsWithChildren) => (
  <div className="bg-gray-100">
    <AskLoginModal />
    <BuildInfo />
    {children}
  </div>
)
